import { ISurvey, ISurveyQuestion } from '../types'
import { ApolloQueryResult } from '@apollo/client'
import { createContext, Dispatch, SetStateAction } from 'react'

export const ManageSurveyContext = createContext<IManageSurveyContext>(
  null as any
)

export interface IManageSurveyContext {
  survey: ISurvey
  refetchSurvey: () => Promise<ApolloQueryResult<any>>
  questions: ISurveyQuestion[]
  setQuestions: Dispatch<SetStateAction<ISurveyQuestion[]>>
}
